import React, {Fragment, useState} from 'react'
import {currentLang} from './../../../utils/functions';
import {siteInfo} from './../../../utils/config';
import { Helmet } from 'react-helmet-async';

function SchemaProduct({data}) {
    // user slider images if exists instead of single image url
    let images = data.main_slider ? data.main_slider.map((item) => {
        return item.image_url;
    }) : [data.image_url];

    let canonicalurl = window.location.origin+window.location.pathname.replace(/\/$/, "");

    let jsonld = {
        "@context": "https://schema.org/",
        "@type": "Product",
        "name": data.title,
        "image": images,
        "brand": {
            "@type": "Brand",
            "name": siteInfo[currentLang()]['domain']
        },
        "description": data.body ? (data.body?.replace(/<[^>]+>/g, '') || "") : "",
        "sku": data.slug,
        "offers": {
            "@type": "Offer",
            "url": canonicalurl,
            "priceCurrency": siteInfo[currentLang()]['currency'],
            "price": data.shop_package_price,
            "availability": data.shop_product_stock_status == 'instock' ? "https://schema.org/InStock" : "https://schema.org/OutOfStock"
        }
    };

    return (
        <Helmet>
        <script type="application/ld+json">
            {JSON.stringify(jsonld)}
        </script>
        </Helmet>
    )
}

export default SchemaProduct
